import type { OptOutNode } from '../../types';
import { ConditionCard } from '../condition-card';
import { Bold } from '../condition-parts';

export function OptOutCondition({ node }: { node: OptOutNode }) {
  const operator = node.inverse ? 'User is not opted out of' : 'User is opted out of';
  return (
    <ConditionCard node={node}>
      {operator} <Bold>{node.channel ?? 'communications'}</Bold>
    </ConditionCard>
  );
}
